import React from 'react';
import { CommandCenterLayout } from '../../components/layout/CommandCenterLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { StatusBadge } from '../../components/ui/StatusBadge';
import { User, MapPin, Phone, Mail, Calendar, CheckCircle2, XCircle, Clock, ExternalLink, Instagram, Facebook, Youtube, TrendingUp, MessageSquare, FileText } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
// Mock Data
const receiverProfile = {
  id: 'RCV-001',
  name: 'Dinas Lingkungan Hidup Kota Surabaya',
  picName: 'Budi Santoso',
  picPhone: '081234567890',
  picEmail: 'dlh.surabaya@example.com',
  region: 'Kota Surabaya, Jawa Timur',
  joinDate: '10 Jan 2024',
  score: 95,
  rank: 1,
  totalPosts: 145,
  socialAccounts: [{
    platform: 'Instagram',
    handle: '@dlh.surabaya',
    status: 'connected'
  }, {
    platform: 'Facebook',
    handle: 'DLH Surabaya Official',
    status: 'connected'
  }, {
    platform: 'TikTok',
    handle: '@dlhsurabaya',
    status: 'connected'
  }]
};
const historyData = [{
  id: 1,
  campaign: 'Kampanye HPSN 2025',
  platform: 'Instagram',
  date: '12 Feb 2025',
  status: 'validated',
  likes: 1250,
  comments: 45,
  url: '#'
}, {
  id: 2,
  campaign: 'Kampanye HPSN 2025',
  platform: 'TikTok',
  date: '12 Feb 2025',
  status: 'validated',
  likes: 5600,
  comments: 120,
  url: '#'
}, {
  id: 3,
  campaign: 'Sosialisasi Bank Sampah',
  platform: 'Facebook',
  date: '05 Feb 2025',
  status: 'rejected',
  likes: 0,
  comments: 0,
  url: '#',
  reason: 'Link tidak bisa dibuka'
}];
const scoreTrend = [{
  month: 'Sep',
  score: 82
}, {
  month: 'Oct',
  score: 85
}, {
  month: 'Nov',
  score: 88
}, {
  month: 'Dec',
  score: 90
}, {
  month: 'Jan',
  score: 92
}, {
  month: 'Feb',
  score: 95
}];
export function ProfilPenerimaPage() {
  return <CommandCenterLayout title="Profil Penerima" subtitle="Detail kinerja dan histori posting daerah" data-id="element-2160">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-2161">
        {/* Left Column: Profile Info */}
        <div className="space-y-6" data-id="element-2162">
          <Card data-id="element-2163">
            <CardContent className="p-6 text-center" data-id="element-2164">
              <div className="h-24 w-24 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-2165">
                <User className="h-12 w-12 text-primary-600" data-id="element-2166" />
              </div>
              <h2 className="text-xl font-bold text-gray-900" data-id="element-2167">
                {receiverProfile.name}
              </h2>
              <div className="flex items-center justify-center gap-2 text-gray-500 mt-1 mb-4" data-id="element-2168">
                <MapPin className="h-4 w-4" data-id="element-2169" /> {receiverProfile.region}
              </div>

              <div className="grid grid-cols-2 gap-4 border-t pt-4 mb-4" data-id="element-2170">
                <div data-id="element-2171">
                  <p className="text-xs text-gray-500" data-id="element-2172">Total Skor</p>
                  <p className="text-2xl font-bold text-primary-600" data-id="element-2173">
                    {receiverProfile.score}
                  </p>
                </div>
                <div data-id="element-2174">
                  <p className="text-xs text-gray-500" data-id="element-2175">Ranking</p>
                  <p className="text-2xl font-bold text-gray-900" data-id="element-2176">
                    #{receiverProfile.rank}
                  </p>
                </div>
              </div>

              <Button className="w-full" variant="outline" data-id="element-2177">
                Edit Profil
              </Button>
            </CardContent>
          </Card>

          <Card data-id="element-2178">
            <CardHeader data-id="element-2179">
              <CardTitle className="text-base" data-id="element-2180">Kontak PIC</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4" data-id="element-2181">
              <div className="flex items-center gap-3" data-id="element-2182">
                <User className="h-5 w-5 text-gray-400" data-id="element-2183" />
                <div data-id="element-2184">
                  <p className="text-sm font-medium text-gray-900" data-id="element-2185">
                    {receiverProfile.picName}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-2186">PIC Utama</p>
                </div>
              </div>
              <div className="flex items-center gap-3" data-id="element-2187">
                <Phone className="h-5 w-5 text-gray-400" data-id="element-2188" />
                <p className="text-sm text-gray-600" data-id="element-2189">
                  {receiverProfile.picPhone}
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-2190">
                <Mail className="h-5 w-5 text-gray-400" data-id="element-2191" />
                <p className="text-sm text-gray-600" data-id="element-2192">
                  {receiverProfile.picEmail}
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-2193">
                <Calendar className="h-5 w-5 text-gray-400" data-id="element-2194" />
                <p className="text-sm text-gray-600" data-id="element-2195">
                  Bergabung: {receiverProfile.joinDate}
                </p>
              </div>
            </CardContent>
          </Card>

          <Card data-id="element-2196">
            <CardHeader data-id="element-2197">
              <CardTitle className="text-base" data-id="element-2198">Akun Terhubung</CardTitle>
            </CardHeader>
            <CardContent className="space-y-3" data-id="element-2199">
              {receiverProfile.socialAccounts.map((acc, idx) => <div key={idx} className="flex items-center justify-between p-2 bg-gray-50 rounded-lg" data-id="element-2200">
                  <div className="flex items-center gap-3" data-id="element-2201">
                    {acc.platform === 'Instagram' && <Instagram className="h-5 w-5 text-pink-600" data-id="element-2202" />}
                    {acc.platform === 'Facebook' && <Facebook className="h-5 w-5 text-blue-600" data-id="element-2203" />}
                    {acc.platform === 'TikTok' && <span className="text-xs font-bold w-5 text-center" data-id="element-2204">
                        TT
                      </span>}
                    <span className="text-sm font-medium" data-id="element-2205">{acc.handle}</span>
                  </div>
                  <Badge variant="success" className="text-[10px]" data-id="element-2206">
                    Connected
                  </Badge>
                </div>)}
            </CardContent>
          </Card>
        </div>

        {/* Right Column: History & Stats */}
        <div className="lg:col-span-2 space-y-6" data-id="element-2207">
          {/* Score Trend Chart */}
          <Card data-id="element-2208">
            <CardHeader data-id="element-2209">
              <CardTitle data-id="element-2210">Tren Skor Kinerja (6 Bulan)</CardTitle>
            </CardHeader>
            <CardContent data-id="element-2211">
              <div className="h-[200px]" data-id="element-2212">
                <ResponsiveContainer width="100%" height="100%" data-id="element-2213">
                  <LineChart data={scoreTrend} data-id="element-2214">
                    <CartesianGrid strokeDasharray="3 3" vertical={false} data-id="element-2215" />
                    <XAxis dataKey="month" axisLine={false} tickLine={false} data-id="element-2216" />
                    <YAxis domain={[0, 100]} axisLine={false} tickLine={false} data-id="element-2217" />
                    <Tooltip data-id="element-2218" />
                    <Line type="monotone" dataKey="score" stroke="#0ea5e9" strokeWidth={3} dot={{
                    r: 4
                  }} data-id="element-2219" />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </CardContent>
          </Card>

          {/* Coaching Notes */}
          <Card className="bg-yellow-50 border-yellow-200" data-id="element-2220">
            <CardHeader data-id="element-2221">
              <div className="flex items-center gap-2" data-id="element-2222">
                <MessageSquare className="h-5 w-5 text-yellow-600" data-id="element-2223" />
                <CardTitle className="text-yellow-900" data-id="element-2224">
                  Catatan Pembinaan
                </CardTitle>
              </div>
            </CardHeader>
            <CardContent data-id="element-2225">
              <div className="space-y-3" data-id="element-2226">
                <div className="p-3 bg-white rounded border border-yellow-100 text-sm text-gray-700" data-id="element-2227">
                  <p className="font-medium text-gray-900 mb-1" data-id="element-2228">
                    10 Feb 2025 - Evaluasi Bulanan
                  </p>
                  <p data-id="element-2229">
                    Kinerja sangat baik, namun perlu ditingkatkan untuk platform
                    TikTok. Disarankan membuat konten video vertikal yang lebih
                    engaging.
                  </p>
                </div>
              </div>
              <Button variant="ghost" size="sm" className="mt-2 text-yellow-700 hover:text-yellow-800 hover:bg-yellow-100 p-0" data-id="element-2230">
                + Tambah Catatan
              </Button>
            </CardContent>
          </Card>

          {/* Posting History */}
          <Card data-id="element-2231">
            <CardHeader data-id="element-2232">
              <CardTitle data-id="element-2233">Histori Posting</CardTitle>
            </CardHeader>
            <CardContent data-id="element-2234">
              <div className="space-y-4" data-id="element-2235">
                {historyData.map(item => <div key={item.id} className="flex items-start gap-4 p-4 border rounded-lg hover:bg-gray-50 transition-colors" data-id="element-2236">
                    <div className={`p-2 rounded-full ${item.status === 'validated' ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'}`} data-id="element-2237">
                      {item.status === 'validated' ? <CheckCircle2 className="h-5 w-5" data-id="element-2238" /> : <XCircle className="h-5 w-5" data-id="element-2239" />}
                    </div>
                    <div className="flex-1" data-id="element-2240">
                      <div className="flex justify-between items-start" data-id="element-2241">
                        <div data-id="element-2242">
                          <h4 className="font-medium text-gray-900" data-id="element-2243">
                            {item.campaign}
                          </h4>
                          <p className="text-sm text-gray-500 flex items-center gap-2" data-id="element-2244">
                            {item.platform} • {item.date}
                          </p>
                        </div>
                        <StatusBadge status={item.status === 'validated' ? 'hijau' : 'merah'} data-id="element-2245">
                          {item.status === 'validated' ? 'Valid' : 'Ditolak'}
                        </StatusBadge>
                      </div>

                      {item.status === 'validated' && <div className="flex gap-4 mt-3 text-sm text-gray-600" data-id="element-2246">
                          <span className="flex items-center gap-1" data-id="element-2247">
                            <span className="font-bold" data-id="element-2248">{item.likes}</span>{' '}
                            Likes
                          </span>
                          <span className="flex items-center gap-1" data-id="element-2249">
                            <span className="font-bold" data-id="element-2250">{item.comments}</span>{' '}
                            Comments
                          </span>
                          <a href={item.url} className="text-blue-600 hover:underline flex items-center gap-1 ml-auto" data-id="element-2251">
                            Lihat Post <ExternalLink className="h-3 w-3" data-id="element-2252" />
                          </a>
                        </div>}

                      {item.status === 'rejected' && <div className="mt-2 p-2 bg-red-50 text-red-700 text-sm rounded border border-red-100" data-id="element-2253">
                          <strong data-id="element-2254">Alasan Penolakan:</strong> {item.reason}
                        </div>}
                    </div>
                  </div>)}
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </CommandCenterLayout>;
}